import TaskStatus from '../store/schema/TaskStatus';

export default function(status: TaskStatus): boolean {
    return status === 'Completed';
}
